import {Legend} from "../../../project/shopdrawing/keying/submittal/Legend";
import {KeyingSchedule, KeyScheduleLine} from "../../../project/shopdrawing/keying/submittal/KeyingSchedule";
import {useReadyCheck} from "../../../../misc/pdf/UseReadyCheck";
import {Keying2Label} from "../../../../api/Keying2";

export type KeyDetails2 = {
    rows: KeyScheduleLine[];
    names: Keying2Label[];
}

export function KeyingDetails(props: {
    value: KeyDetails2;
    onReady(): void;
}) {
    const ready = useReadyCheck(props.onReady);
    const {names, rows} = props.value;

    return (
        <>
            <Legend names={names} noProject />
            <KeyingSchedule rows={rows} names={names} onReady={ready.section()} />
        </>
    )
}